export default __webpack_public_path__ + "static/media/UserRfpReport.f04f2d27.svg";